import Model from '../Model'
import Article from './Article'

export default class Category extends Model {
  resource () {
    return 'blog/categories'
  }

  primaryKey () {
    return 'slug'
  }

  articles () {
    return this.hasMany(Article)
  }
}
